module.exports = __webpack_public_path__ + "img/home_banner_pic01_PC_1920x400.e21370f0.jpg";